import { Analytics } from "@/pagesComponents/Analytics/Analytics";
import { Meta } from "@/pagesComponents/Meta/Meta";
import NoResults from "@/pagesComponents/NoResults/NoResults";
import { getServerSideProps } from "@/getServerSideProps/getServerSideProps.ts";
import { layoutMap } from "@/layouts/layoutMap.ts";
import { raise } from "@/utils/raise.ts";
import { InferGetServerSidePropsType } from "next";
import { useProductListingData } from "@/contexts/ProductListingDataContext/ProductListingDataContext";
import { StructuredData } from "@/pagesComponents/StructuredData/StructuredData";
import dynamic from "next/dynamic";

const ErrorPage = dynamic(() => import("@/pagesComponents/Error/ErrorPage"), {
  ssr: true,
});

export { getServerSideProps } from "@/getServerSideProps/getServerSideProps.ts";

export default function Page(
  props: InferGetServerSidePropsType<typeof getServerSideProps>,
) {
  const productListingData = useProductListingData();

  if (props.type === "error") return <ErrorPage />;

  if (props.productListingData.results === 0) {
    return (
      <>
        <Analytics {...props} />
        <Meta
          productListingData={productListingData || props.productListingData}
        />
        <NoResults {...props} />
      </>
    );
  }

  const statefulProps = {
    ...props,
    productListingData: productListingData || props.productListingData,
  };

  const { pageConfig } = statefulProps;

  const Layout =
    layoutMap[pageConfig.layout.name] ||
    raise(`Couldn't find layout "${pageConfig.layout.name}"`);

  return (
    <>
      <Analytics {...statefulProps} />
      <Meta {...statefulProps} />
      <StructuredData {...statefulProps} />
      <Layout {...statefulProps} />
    </>
  );
}
